











import { Tag, ThemeTreeItem } from "@/api/models";
import { notEmptyString } from "@/api/validators";
import { SiteState, SubmissionState } from "@/store/types";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import HelpWidget from "./HelpWidget.vue";

@Component({
  components: { HelpWidget },
})
export default class ThemeTree extends Vue {
  @Prop({ default: "Theme" }) label: string;
  @Prop({ default: "sub-themes" }) subLabel: string;
  @State("site") site: SiteState;
  @State("submission") submission: SubmissionState;

  slug = "";

  subSlugs: string[] = [];

  created() {
    this.sync();
  }

  get themes() {
    return this.site.themes.map((item, index) => new ThemeTreeItem(item, index));
  }

  get subThemes() {
    let tags: Tag[] = [];
    if (notEmptyString(this.slug)) {
      const par = this.site.themes.find(row => row.slug === this.slug);
      if (par instanceof Object) {
        const { children } = par;
        if (children instanceof Array) {
          tags = children.map((row, index) => new Tag(row, index));
        }
      }
    }
    return tags;
  }

  get showSubThemes(): boolean {
    return this.subThemes.length > 0;
  }

  get subThemeLabel() {
    return this.subThemes.length > 0 ? this.subLabel : '';
  }

  sync() {
    const { themes, subthemes } = this.submission;
    if (themes.length > 0) {
      this.slug = themes[0].slug;
      if (subthemes.length > 0) {
        setTimeout(() => {
          this.subSlugs = subthemes.map(row => row.slug);
        }, 250)
      }
    }
  }

  syncTheme() {
    const par = this.site.themes.find(row => row.slug === this.slug);
    const hasTheme = par instanceof Object;
    const subthemes = hasTheme ? this.subThemes.filter(row => this.subSlugs.includes(row.slug)) : [];
    const themes =  hasTheme ? [new Tag(par)] : []
    this.$emit('update', { themes, subthemes })
  }

  @Watch('slug')
  changeSlug() {
    this.syncTheme();
  }

  @Watch('subSlugs')
  changeSubSlugs() {
    this.syncTheme();
  }

}
